import React, { useState, useEffect } from "react";

const BASE_URL = process.env.REACT_APP_BASE_URL || "http://localhost:5000";
function BrowseCareer() {
  const [posts, setPosts] = useState("");
  const [fetchingErr, setFetchingErr] = useState(null);
  const [searchValue, setSeacrhValue] = useState();
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    // Fetch blog posts from API
    // Example: Fetching from an API endpoint
    setLoading(true);
    fetch(`${BASE_URL}/api/career/getposts`)
      .then((response) => response.json())
      .then((data) => {
        setPosts(data)
        setLoading(false);
      })
      .catch((error) => {setFetchingErr(error.message)
        setLoading(false);
  });
  }, []);

  const handleDelete = (postId) => {
    // Delete post API call
    fetch(`${BASE_URL}/api/career/deletepost/${postId}`, {
      method: "DELETE",
    })
      .then((response) => {
        if (response.ok) {
          // Update the state to remove the deleted post
          setPosts(posts.filter((post) => post._id !== postId));
          alert("Post Deleted");
        }
      })
      .catch((error) => alert(`Failed to Delete : ${error} `));
  };

  const handleSearch = () => {
    if(posts){
      return posts?.filter((post) => {
        return post.name?.toLowerCase().includes(searchValue) ;
      });
    }
  };

  useEffect(() => {
    handleSearch();
  }, []);

  return (
    <div className="container py-4">
      {/* Search Bar */}
      <div className="row mb-3">
        <div className="col-12 col-md-6 text-start">
          <div className="input-group">
            <input
              type="text"
              className="form-control shadow-sm"
              style={{
                borderRadius: "6px",
                borderColor: "#d0d5dd",
                padding: "0.65rem 0.85rem",
              }}
              placeholder="Search Career Post by Title..."
              value={searchValue || ""}
              onChange={(e) => {
                setSeacrhValue(e.target.value);
              }}
            />
          </div>
        </div>
      </div>
      <div className="row">
        {loading ? (
          <div className="col-12 text-center py-5">
            <div className="spinner-border text-primary" role="status"></div>
          </div>
        ) : fetchingErr ? (
          <div className="col-12 text-danger text-center py-5">{fetchingErr}</div>
        ) : (
          <>
            {handleSearch && handleSearch()?.length > 0 ? (
              handleSearch().map((post) => (
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={post._id}>
                  <div className="card h-100 shadow-sm" style={{ borderRadius: "10px", borderColor: "#d0d5dd" }}>
                    <div className="card-body d-flex flex-column justify-content-between text-start">
                      <h5 className="card-title fw-semibold" style={{ color: "#333" }}>{post.name}</h5>
                      <hr />
                      <div className="d-flex justify-content-end gap-2">
                        <button
                          className="btn btn-outline-danger btn-sm d-flex align-items-center"
                          onClick={() => handleDelete(post._id)}
                          style={{ borderRadius: "4px" }}
                          title="Delete"
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                        <button
                          className="btn btn-outline-primary btn-sm d-flex align-items-center"
                          style={{ borderRadius: "4px" }}
                          disabled
                          title="Edit"
                        >
                          <i className="bi bi-pencil-square"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : !searchValue && posts && posts.length > 0 ? (
              posts?.map((post) => (
                <div className="col-lg-3 col-md-4 col-sm-6 mb-4" key={post._id}>
                  <div className="card h-100 shadow-sm" style={{ borderRadius: "10px", borderColor: "#d0d5dd" }}>
                    <div className="card-body d-flex flex-column justify-content-between text-start">
                      <h5 className="card-title fw-semibold" style={{ color: "#333" }}>{post.name}</h5>
                      <hr />
                      <div className="d-flex justify-content-end gap-2">
                        <button
                          className="btn btn-outline-danger btn-sm d-flex align-items-center"
                          onClick={() => handleDelete(post._id)}
                          style={{ borderRadius: "4px" }}
                          title="Delete"
                        >
                          <i className="bi bi-trash"></i>
                        </button>
                        <button
                          className="btn btn-outline-primary btn-sm d-flex align-items-center"
                          style={{ borderRadius: "4px" }}
                          disabled
                          title="Edit"
                        >
                          <i className="bi bi-pencil-square"></i>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12 text-center mt-5">
                {handleSearch && searchValue ? (
                  <div className="alert alert-warning">Oops! No posts found.</div>
                ) : null}
                {posts && posts.length === 0 ? (
                  <div className="alert alert-info">
                    The Post bucket is Empty, please create posts.
                  </div>
                ) : null}
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default BrowseCareer;


